<template>
    <div style="height: calc(100vh - 190px); position: relative; overflow: hidden;">
        <pm-extras-header :total="total" :percentage="percentageValue" />

        <div v-show="showAllOptions" style="height: calc(100vh - 176px); padding-bottom: 60px; overflow-y: auto;" class="all-options">

            <div v-if="demoPrices" class="demo-prices-notification">
                <div @click="$router.push('pricelist')" class="pink lighten-2 white--text" style="text-align: center; font-size: 12px; border-radius: 7px; padding: 6px 12px; margin: 20px 16px 0px 16px;" v-html="$t('welcome.demo_prices_desc')"></div>
            </div>

                 <div v-for="(step, i) in _steps" :key="i">
                     <template v-if="step.isGroup && step.groupId === 5"></template>
                     <div v-else-if="step.isGroup && step.groupId !== 5" style="display: flex; padding: 12px 16px; box-shadow: inset 0 8px 15px rgba(0,0,0,.05);" class="blue--text text--accent-3 grey lighten-5">
                        <span class="overview--sub-title roboto f13 bold--text">{{ getTitle(step) }}</span>
                     </div>
                     <pm-step-stepper
                        v-else-if="!step.isPercentage || ($store.state.simplePlan.upperJawTotal + $store.state.simplePlan.lowerJawTotal > 0)"
                        v-model="step.amount"
                        show-price
                        :unit-price="step.unit_price"
                        :step="step.isPercentage ? 2 : 1"
                        :title="getTitle(step)"
                        :max="step.maxAmount"
                        :min="step.minAmount"
                        @input="updateStepAmount(step)"
                    >
                        <template v-if="step.isPercentage" slot="unit-price">
                            {{ step.amount }}% = <pm-price :value="Math.round(($store.state.simplePlan.upperJawTotal + $store.state.simplePlan.lowerJawTotal) * (step.amount / 100))" />
                        </template>
                        <template v-if="step.isPercentage" slot="addons">
                            <v-icon style="margin: 0 0 0 16px;" class="black--text" @click="resetStep(step)">
                                reset
                            </v-icon>
                        </template>
                        <span slot="addons" v-if="!step.isGroup && !step.isPercentage" style="position: relative; margin: 0 0 0 16px;" @click="$bus.$emit('openAppDialog', 'toothIdSelector', step)">
                            <mdi style="color: #666;" v-show="typeof step.toothIds !== 'undefined' && step.toothIds.length > 0">mdiTooth</mdi>
                            <mdi style="opacity: .5;" v-show="typeof step.toothIds === 'undefined' || step.toothIds.length === 0">mdiToothOutline</mdi>
                            <div style="position: absolute; top: -6px; right: -1px; width: 0; height: 0; border-style: solid; border-width: 0 8px 16px 8px; border-color: transparent transparent #fff transparent;" v-show="typeof step.toothIds !== 'undefined' && step.toothIds.length>0 && step.toothIds.length !== step.amount"></div>
                            <mdi style="position: absolute; margin: -6px 0 0 -12px; color: #ec3c7a;" size="16" v-show="typeof step.toothIds !== 'undefined' && step.toothIds.length>0 && step.toothIds.length !== step.amount">mdiAlert</mdi>
                        </span>
                    </pm-step-stepper>
                </div>
            <v-layout style="justify-content: center; margin: 2rem 0">
                <v-btn
                    class="roboto f13 blue--text text--accent-3 bold--text btn--add-treatment"
                    flat
                    style="margin: 0 !important; height: auto; border: 2px solid #2979ff; padding: 4px 16px; border-radius: 24px; position: relative;"
                    @click="goToOtherTreatments"
                >
                    <v-icon style="margin-right: 8px" v-text="'add'" /> {{ $t("plan_calculator.add_treatment") }}
                </v-btn>
            </v-layout>


            <div>
                <div style="display: flex; padding: 12px 16px; box-shadow: inset 0 8px 15px rgba(0,0,0,.05); display: flex; align-items: center;" class="blue--text text--accent-3 grey lighten-5">
                    <span class="overview--sub-title roboto f13 bold--text" style="flex-grow: 1;">{{ $t("plan_calculator.discount") }}</span>



                    <div :key="$store.state.simplePlan.discountMode" style="display: inline-block; white-space: nowrap; margin-left: 8px; border-radius: 28px;">
                        <div @click="setDiscountMode('percentage')" style="display: inline-block; padding: 4px 12px 4px 16px; border-top-left-radius: 28px; border-bottom-left-radius: 28px;"
                        :style="$store.state.simplePlan.discountMode === 'percentage' ? 'border: 2px solid #2979ff;' : 'border: 2px solid #ddd; border-right-width: 0px !important'">%</div>
                        <div @click="setDiscountMode('currency')" style="display: inline-block; padding: 4px 16px 4px 12px; border-top-right-radius: 28px; border-bottom-right-radius: 28px;"
                        :style="$store.state.simplePlan.discountMode !== 'percentage' ? 'border: 2px solid #2979ff;' : 'border: 2px solid #ddd; border-left-width: 0px !important'">{{ currencySymbol }}</div>
                        </div>
                </div>
                <div style="padding: 10px 16px; display: flex;">
                    <span style="flex-grow: 1;" class="roboto black--text f15 step-stepper--title">{{ $t("plan_calculator.total_without_discount") }}</span>
                    <pm-price :value="getFullTotal()" />
                </div>
                <div style="padding: 10px 16px; display: flex;">
                    <span class="roboto black--text f15 step-stepper--title" style="flex-grow: 1;">{{ $t("plan_calculator.discount") }}</span>
                    <div style="display: flex;">
                        <small v-if="$store.state.simplePlan.discountMode === 'currency' && currencySettings.position === 'left'">{{ currencySymbol }}</small>
                        <v-text-field :maxlength="$store.state.simplePlan.discountMode === 'currency' ? 9 : 2" class="input-right-aligned" hide-details style="text-align: right; width: 80px; margin: -10px 8px 0 0; padding: 0;" @blur="onDiscountInput" type="text" v-model="$store.state.simplePlan.discountAmount" />
                        <small v-if="$store.state.simplePlan.discountMode === 'percentage'">%</small>
                        <small v-if="$store.state.simplePlan.discountMode === 'currency' && currencySettings.position !== 'left'">{{ currencySymbol }}</small>
                    </div>
                </div>
                <div style="padding: 6px 16px 10px 16px;  display: flex;">
                    <span style="flex-grow: 1;" class="roboto black--text f15 step-stepper--title">
                        {{ $t("plan_calculator.total_with_discount") }}
                    </span>
                    <pm-price style="font-weight: 600; font-size: 16px;" :key="$store.state.simplePlan.discountMode + $store.state.simplePlan.discountAmount" :value="getFullTotal() - calculateDiscount()" />
                </div>
            </div>
            <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        </div>
    </div>
</template>

<style>
.input-right-aligned * {
    text-align: right;
}
@media (min-width: 700px) {

    .overview--sub-title {
        font-size: 20px !important;
    }

    .btn--add-treatment {
        padding: 8px 30px !important;
        font-size: 16px !important;
        border-radius: 50px !important;
    }

    .all-options > div > div {
        padding: 10px 36px !important;
    }
}
</style>

<script>
import PmExtrasHeader from "./extras-header";
import PmStepStepper from "./step-stepper";
import { getFullTotal, calculateDiscount } from "./plan";
import { getCurrencySettings, getCurrencySymbol } from '@/utils/currency';
export default {
    components: {
        PmExtrasHeader,
        PmStepStepper,
    },
    props: {
        showToggler: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        extraStepAmounts: {},
        _steps: [],
        total: 0,
        showAllOptions: true,
        groupedItems: [],
        percentageValue: 0,
        demoPrices: false,
        currencySettings: getCurrencySettings(app.$store.state.currency),
        currencySymbol: getCurrencySymbol(app.$store.state.currency),
    }),
    activated() {
        this.extendExtraSteps();
    },
    created() {
        this.groupedItems = this.$store.getters["smart/groupedTreatments"](false);

        this._steps = this.getSuggestions();
        this.recalcExtras();
        this.registerBusEvent("reset/extras", () => {
            this._steps.forEach((step) => {
                step.amount = 0;
                step.toothIds = [];
            });
            this.recalcExtras();
            this.$forceUpdate();
            this.$set(this.$store.state.simplePlan, "emailSent", false);
            this.$set(this.$store.state.simplePlan, "discountAmount", 0);
        });

        if (localStorage.getItem("priceListVisited") !== "true") this.demoPrices = true;

        this.registerBusEvent("toothIdSelectionUpdated", this.recalcExtras);
    },
    methods: {
        onDiscountInput() {
            let value = parseInt(this.$store.state.simplePlan.discountAmount);
            if(isNaN(value)) value = 0;
            this.$store.state.simplePlan.discountAmount = value;
        },
        getFullTotal() {
            return getFullTotal();
        },
        calculateDiscount() {
            return calculateDiscount();
        },
        setDiscountMode(mode) {
            this.$store.state.simplePlan.discountMode = mode;
            this.$store.state.simplePlan.discountAmount = 0;
            this.$forceUpdate();
        },
        async goToOtherTreatments() {
            await this.$router.push("/pricelist#group_5").catch(() => {});
        },
        getTitle(step) {
            if (typeof step.state_id !== 'undefined') return this.$store.getters["smart/titleOfTreatment"](step.state_id, this.$store.state.language, false);
            if (step.isGroup && typeof step.groupId !== 'undefined') return this.$t("plan_calculator.group_" + step.groupId);
            if (step.isPercentage) return this.$t("extra_treatments.other");
            return step.title;
        },
        resetStep(step) {
            step.amount = 0;
            this.recalcExtras();
            this.$emit('updated');
            this.$set(this.$store.state.simplePlan, "emailSent", false);
        },

        // Can be used by parent
        modifyStepAmount(step, amount) {
            if (amount === 1 && step.amount < step.maxAmount) step.amount++;
            if (amount === -1 && step.amount > step.minAmount) step.amount--;
            this.recalcExtras();
            this.$forceUpdate();
            this.$set(this.$store.state.simplePlan, "emailSent", false);
        },

        updateStepAmount(step) {
            if (!step.isPercentage) {
                console.log(step);
                step.selectionMode = 'amount';
                if (step.amount === 0) step.toothIds = [];
            }
            this.recalcExtras();
        },

        recalcExtras() {
            let total = 0;

            // TODO kiemelni a szazalekot, majd megnezni hogy hol van meg

            this._steps.forEach((step) => {
                if (step.isPercentage) {
                    this.percentageValue = step.amount;

                    return;
                }

                total += step.unit_price * step.amount;
            });

            this.total = total;
            this.$set(this.$store.state.simplePlan, "extraTotal", total);
            this.$emit('updated');
        },


        generateExtraSteps() {
            const steps = [];

            // const groups = [5, 1, 6, 7, 2, 3];
            const groups = [5, 3];

            groups.forEach((groupId) => {
                steps.push({
                    amount: 0,
                    unit_price: 0,
                    title: this.$t("plan_calculator.group_" + groupId),
                    isGroup: true,
                    groupId: groupId,
                    jaw: "",
                });
                let groupAdded = false;

                Object.values(this.$store.state.localSettings.dentalStates).forEach((item) => {
                    if (parseInt(item.group) !== groupId) return false;
                    if (parseInt(item.status) !== 1) return false;
                    if (parseInt(item.hidden) === 1) return false;
                    steps.push({
                        state_id: item.id,
                        title: this.$store.getters["smart/titleOfTreatment"](item.id, this.$store.state.language, false),
                        amount: 0,
                        minAmount: 0,
                        maxAmount: 99,
                        unit_price: this.$store.getters["smart/priceOfTreatment"](item.id, this.$store.state.currency),
                        jaw: "",
                    });
                    groupAdded = true;
                });

                if (!groupAdded) steps.pop();

                if (groupId === 5) {
                    steps.push({
                        title: this.$t("extra_treatments.other"),
                        amount: 0,
                        minAmount: 0,
                        maxAmount: 99,
                        unit_price: "5000",
                        isPercentage: true,
                        jaw: "",
                    });
                }
            });

            return steps;
        },

        extendExtraSteps() {
            if (this.$store.state.simplePlan.extraSteps.length === 0) return;

            const ids = [];

            this.$store.state.simplePlan.extraSteps.forEach((step) => {
                if (step.state_id) ids.push(step.state_id);
            });

            Object.values(this.$store.state.localSettings.dentalStates).forEach((item) => {
                if (parseInt(item.group) !== 5) return false;
                if (parseInt(item.status) !== 1) return false;
                if (parseInt(item.hidden) === 1) return false;
                if (ids.includes(item.id)) return false;

                let index = 0;

                this.$store.state.simplePlan.extraSteps.forEach((s, idx) => {
                    if (s.isPercentage === true) index = idx;
                });

                const newStep = {
                    state_id: item.id,
                    title: this.$store.getters["smart/titleOfTreatment"](item.id, this.$store.state.language, false),
                    amount: 0,
                    minAmount: 0,
                    maxAmount: 99,
                    unit_price: this.$store.getters["smart/priceOfTreatment"](item.id, this.$store.state.currency),
                    jaw: "",
                };

                this.$store.state.simplePlan.extraSteps.splice(index, 0, newStep);
            });
        },

        getSuggestions() {
            let steps = this.$store.state.simplePlan.extraSteps;

            if (steps.length === 0) {
                steps = this.generateExtraSteps();
                steps.forEach((step) => {
                    this.$store.state.simplePlan.extraSteps.push(step);
                });
            }

            return steps;
        },
    },
};
</script>
